import { memo } from 'react';

import { DrawerBox } from './DrawerSidebar.styles';
import { DrawerSidebarProps } from './DrawerSidebar.types';

export const DrawerSidebar = memo(({ visibility, children, ...rest }: DrawerSidebarProps): JSX.Element => {
  return (
    <DrawerBox anchor="right" open={visibility} {...rest}>
      {children}
    </DrawerBox>
  );
});

DrawerSidebar.displayName = 'DrawerSidebar';
